import { Button, Checkbox, Col, DatePicker, Input, Row, Select } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onChange, onCloseFilter, onReset, onSubmit, getListChannelShipment } from './../../../../actions/shipmentAction';
import InputFormat from './../../../../components/input-format';
import { convertDateToUTC } from './../../../../services/dst';
import { CheckFullSizeHalfSize, renderSelectAntTitle } from './../../../../services/helper';
import { StatusFilterShipment, FulfillOption as FulfillOptionConst } from './../../../../constants';
import './styles.css';

const CheckboxGroup = Checkbox.Group
const Option = Select.Option;
const dateFormat = 'MM/DD/YYYY';


const optionsType = [
    { label: 'Imported', value: 1 },
    { label: 'Manual', value: 2 },
]

class AddFilterShipment extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.selectChannelOptionPlace = this.selectChannelOptionPlace.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.add_filter) {
            let filter = document.querySelector('.add-filter-shipment')
            if (filter) {
                filter.onkeydown = function (e) {
                    if (e.key === 'Enter') {
                        document.getElementsByClassName('display')[0].click()
                    }
                }
            }
        }
        let options = [];

        if (props.typeListShipment === FulfillOptionConst.YAMATO.TYPE_LINK) {
            options = [
                { label: 'Fulfillment In Process', value: StatusFilterShipment.FULFILLMENT_IN_PROCESS },
                { label: 'Shipping In Process', value: StatusFilterShipment.SHIPPING_IN_PROCESS },
                { label: 'Fulfillment Completed', value: StatusFilterShipment.FULFILLMENT_COMPLETED },
                { label: 'Shipped', value: StatusFilterShipment.SHIPPED },
                { label: 'In Transit', value: StatusFilterShipment.IN_TRANSIT },
                { label: 'Delivered', value: StatusFilterShipment.DELIVERED },
            ]
        } else {
            options = [
                { label: 'Awaiting Package Information', value: StatusFilterShipment.AWAITING_PACKAGE_INFO },
                { label: 'Ready To Print', value: StatusFilterShipment.READY_TO_PRINT },
                { label: 'Ready To Transmit', value: StatusFilterShipment.READY_TO_TRANSMIT },
                { label: 'Shipped', value: StatusFilterShipment.SHIPPED },
                { label: 'In Transit', value: StatusFilterShipment.IN_TRANSIT },
                { label: 'Delivered', value: StatusFilterShipment.DELIVERED },
            ]
        }
        return {
            options
        }
    }

    componentDidMount() {
        this.props.getListChannelShipment()
    }

    onChange = (value, maxLength) => {
        let wordMax = CheckFullSizeHalfSize(value, maxLength)
        if (!wordMax) return;
        this.props.onChange({ value: value, column: 'channel_order_no' })
    }

    renderListChannel = () => {
        return this.props.shipmentReducer.listChannel.map((e, i) => {
            return (
                <Option key={i} value={String(e.ID)}>{e.Name}</Option>
            )
        })
    }

    /**
     * filter option for select channel
     */
    selectsFilterChannel = (inputValue, option) => {
        if (option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) {
            return true;
        }
        return false;
    }

    /**
     * custom show text and title select channel if chooes multi channel
     */
    selectChannelOptionPlace = (omittedValues) => {
        return renderSelectAntTitle(omittedValues, this.props.shipmentReducer.listChannel);
    }

    handleFilterChannel = (e) => {
        let maxTagCount = 2;
        if(e.length > 2) {
            maxTagCount = 1
        }
        this.props.onChange({ value: e, column: 'channel' })
        this.props.onChange({ value: maxTagCount, column: 'maxTagCount' })
    }

    render() {
        if (this.props.add_filter) {
            return (
                <Col span={24}>
                    <div className="add-filter-shipment">
                        <Row>
                            <Col span={3}>
                                <h3 className="add-filter-title">Add Filters</h3>
                            </Col>

                            <Col span={1} offset={20}>
                                <span className='close-filter'
                                    style={{ float: 'right', cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.closeFilter()
                                    }}>X</span>
                            </Col>
                        </Row>
                        <Row gutter={16} >
                            <Col span={3}>
                                <div className="filter-title">
                                    <span>Channel</span>
                                </div>
                                <div className="filter-channel filter-status">
                                    <Select
                                        mode="multiple"
                                        className="select-filter-multi"
                                        style={{ width: '100%' }}
                                        placeholder="Select Channel"
                                        onChange={this.handleFilterChannel}
                                        value={this.props.sub_input_filter.channel}
                                        maxTagCount={this.props.sub_input_filter.maxTagCount}
                                        filterOption={this.selectsFilterChannel}
                                        maxTagPlaceholder={this.selectChannelOptionPlace}
                                    >
                                       {this.renderListChannel()}
                                    </Select>
                                </div>
                            </Col>
                            <Col className="filter-col" span={3}>
                                <div className="filter-title">
                                    <span>Channel Order #</span>
                                </div>
                                <div className="filter-channel-orders">
                                    <Input
                                        size="small"
                                        value={this.props.sub_input_filter.channel_order_no}
                                        onChange={e => this.onChange(e.target.value, 60)}
                                    />
                                </div>
                            </Col>
                            <Col span={4}>
                                <div className="filter-title">
                                    <span>Type</span>
                                </div>
                                <div className="filter-status">
                                    <CheckboxGroup
                                        options={optionsType}
                                        defaultValue={this.props.sub_input_filter.type_list}
                                        value={this.props.sub_input_filter.type_list}
                                        onChange={e => this.props.onChange({ value: e, column: 'type_list' })}
                                    />
                                </div>
                            </Col>
                            <Col className="filter-col" span={13}>
                                <div className="filter-title">
                                    <span>Status</span>
                                </div>
                                <div className="filter-status">
                                    <CheckboxGroup
                                        options={this.state.options}
                                        defaultValue={this.props.sub_input_filter.status_list}
                                        value={this.props.sub_input_filter.status_list}
                                        onChange={e => this.props.onChange({ value: e, column: 'status_list' })}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col className="filter-col" span={7}>
                                <div className="filter-title">
                                    <span>Tracking Number</span>
                                </div>
                                <div className="filter-date-order">
                                    <span>From &nbsp;&nbsp;</span>
                                    <InputFormat
                                        onChange={(value) => this.props.onChange({ value: value, column: 'tracking_number_from' })}
                                        value={this.props.sub_input_filter.tracking_number_from ? this.props.sub_input_filter.tracking_number_from : null}
                                        decimal={[12, 0]}
                                        size="small"
                                        className="ant-input-sm"
                                        isRedstar={false}
                                    />
                                    <span>&nbsp;&nbsp;To &nbsp;</span>
                                    <InputFormat
                                        onChange={(value) => this.props.onChange({ value: value, column: 'tracking_number_to' })}
                                        value={this.props.sub_input_filter.tracking_number_to ? this.props.sub_input_filter.tracking_number_to : null}
                                        decimal={[12, 0]}
                                        size="small"
                                        className="ant-input-sm"
                                        isRedstar={false}
                                    />
                                </div>
                            </Col>
                            <Col className="filter-col" span={8}>
                                <div className="filter-title">
                                    <span>Order Date</span>
                                </div>
                                <div className="filter-date-order filter-date-order-about">
                                    <span>From &nbsp;&nbsp;&nbsp;</span>
                                    <DatePicker
                                        size={'small'}
                                        value={this.props.sub_input_filter.order_date_from ? moment(this.props.sub_input_filter.order_date_from, dateFormat) : null}
                                        onChange={(e, eToString) => this.props.onChange({ value: eToString, column: 'order_date_from' })}
                                        format={dateFormat}
                                    />
                                    <span>&nbsp;To &nbsp;&nbsp;&nbsp;</span>
                                    <DatePicker
                                        size={'small'}
                                        value={this.props.sub_input_filter.order_date_to ? moment(this.props.sub_input_filter.order_date_to, dateFormat) : null}
                                        onChange={(e, eToString) => this.props.onChange({ value: eToString, column: 'order_date_to' })}
                                        format={dateFormat}
                                    />
                                </div>
                            </Col>
                            <Col className="filter-col" span={8}>
                                <div className="filter-title">
                                    <span>Ship Date</span>
                                </div>
                                <div className="filter-date-order filter-date-order-about">
                                    <span>From &nbsp;</span>
                                    <DatePicker
                                        size={'small'}
                                        value={this.props.sub_input_filter.shipping_date_from ? moment(this.props.sub_input_filter.shipping_date_from, dateFormat) : null}
                                        onChange={(e, eToString) => this.props.onChange({ value: eToString, column: 'shipping_date_from' })}
                                        format={dateFormat}
                                    />
                                    <span>&nbsp;To &nbsp;</span>
                                    <DatePicker
                                        size={'small'}
                                        value={this.props.sub_input_filter.shipping_date_to ? moment(this.props.sub_input_filter.shipping_date_to, dateFormat) : null}
                                        onChange={(e, eToString) => this.props.onChange({ value: eToString, column: 'shipping_date_to' })}
                                        format={dateFormat}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="btn-action">
                            <Col span={6} offset={9}>
                                <Button htmlType="reset" className="clear" size="large" onClick={() => this.props.onReset({ PageSize: this.props.getShipmentParams.PageSize, FulfillmentOption: this.props.getShipmentParams.FulfillmentOption })}>
                                    Reset
                                </Button>
                                <Button
                                    htmlType="submit"
                                    className="display ant-btn-primary"
                                    size="large"
                                    onClick={() => this.props.onSubmit({ ...this.props.getShipmentParams, Page: 1 })}
                                >
                                    Apply
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Col>
            )
        } else return null
    }
}

const mapStateToProps = state => {
    let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
    let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'
    return {
        add_filter: state.shipmentReducer.add_filter,
        sub_input_filter: state.shipmentReducer.sub_input_filter,
        orderBy: state.shipmentReducer.orderBy,
        isDesc: state.shipmentReducer.isDesc,
        shipmentReducer: state.shipmentReducer,
        getShipmentParams: {
            Status: state.shipmentReducer.sub_input_filter.status_list,
            Type: state.shipmentReducer.sub_input_filter.type_list,
            OrderDateFrom: convertDateToUTC(new Date(state.shipmentReducer.sub_input_filter.order_date_from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.shipmentReducer.sub_input_filter.order_date_to + ' 23:59:59')),
            ShippingDateFrom: convertDateToUTC(new Date(state.shipmentReducer.sub_input_filter.shipping_date_from + ' 00:00:00')),
            ShippingDateTo: convertDateToUTC(new Date(state.shipmentReducer.sub_input_filter.shipping_date_to + ' 23:59:59')),
            StartToday: convertDateToUTC(new Date(startToday)),
            EndToday: convertDateToUTC(new Date(endToday)),
            TrackingNumberFrom: state.shipmentReducer.sub_input_filter.tracking_number_from,
            TrackingNumberTo: state.shipmentReducer.sub_input_filter.tracking_number_to,
            OrderBy: state.shipmentReducer.orderBy,
            IsDesc: state.shipmentReducer.isDesc,
            PageSize: state.shipmentReducer.offset,
            Page: state.shipmentReducer.current_page,
            ChannelOrderID: state.shipmentReducer.sub_input_filter.channel_order_no,
            ChannelID: state.shipmentReducer.sub_input_filter.channel,
            FulfillmentOption: state.shipmentReducer.fulfillment_option
        },
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        onReset: payload => {
            dispatch(onReset(payload))
        },

        closeFilter: () => {
            dispatch(onCloseFilter())
        },
        getListChannelShipment: () => {
            dispatch(getListChannelShipment())
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFilterShipment)



// WEBPACK FOOTER //
// ./src/containers/shipments/components/add-filter/index.js